import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgWordpressRegularIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 32 32",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#clip0_14000_333)",
		children: /* @__PURE__ */ _jsx("path", {
			fill: "#00759D",
			fillRule: "evenodd",
			d: "M2 16a14 14 0 0 0 7.9 12.6L3.2 10.3A14 14 0 0 0 2 16m23.5-.7c0-1.7-.7-3-1.2-3.9q-1.2-1.6-1.4-3.3c0-1.2 1-2.4 2.4-2.4h.2A14 14 0 0 0 4.3 8.3h.9l3.7-.2c.8 0 .9 1.1.1 1.2l-1.6.1 5.1 15.2 3-9.2-2.1-6-1.5-.1c-.7 0-.6-1.2.1-1.2l3.7.2 3.7-.2c.8 0 .9 1.1.1 1.2l-1.6.1 5 15 1.5-4.6q1-2.9 1-4.5m2.8-6v1.4q.1 2-1 5L23 28.1a14 14 0 0 0 5.3-18.8m-12 8-4.3 12a14 14 0 0 0 8.6-.2V29z",
			clipRule: "evenodd"
		})
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_14000_333",
		children: /* @__PURE__ */ _jsx("path", { d: "M2 2h28v28H2z" })
	}) })]
});
export default SvgWordpressRegularIcon;
